// Check if the current URL matches the desired one
if (window.location.href === "https://beautytribe.com/pages/personalized-skincare") {
    // Select the element by its class
    const pageTitle = document.querySelector('.page-title');
    // Remove the element if it exists
    if (pageTitle) {
        pageTitle.remove();
    }
}

window.addEventListener('message', function(e) {
        
	    var $iframe = document.getElementById('renude-analysis');
	    var eventName = e.data[0];
	    var data = e.data[1];
	    switch(eventName) {
	        case 'setHeight':
	            $iframe.height = data;
	            break;
	        case 'setTopByWindow':
	          window.scrollTo({ top: data - 100, behavior: 'smooth' });
	          break;
	        case 'setTopByIframe':
	           $iframe.scrollIntoView({behavior: 'smooth', block: 'start'});
	          break;
	    }
	    if (e.data.action === 'addToCart') {
	   	  /*
			We need to update the below code. the renude iframe's postmessage will send product variantID and quantity.
			{
				action: 'addToCart',
				item: 8445857628424,
				quantity: 1
			}
			window.parent.postMessage({ action: 'addToCart', item: `${8445857628424}`}, '*');
			This postMessage events will be handled by this code block. So we need to add some code to show updated bag icon with count of products or showing cart slide panel. As you can imagine, we should update this if statement code block to archive the goal.
	   	  */
	      // Add item to Shopify cart
	      fetch('/cart/add.js', {
	        method: 'POST',
	        headers: {
	          'Content-Type': 'application/json',
	        },
	        body: JSON.stringify({
	          id: e.data.item,  // product variantID
	          quantity: e.data.quantity
	        }),
	      })
	      .then(response => response.json())
	      .then(data => {
	        // Optionally, update the cart UI
	        console.log('Item added to cart:', data);
	      })
	      .catch(error => {
	        console.error('Error adding item to cart:', error);
	      });
	    }
	}, false);